var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWhiteGlove = function SvgWhiteGlove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 11,
    viewBox: "0 0 22 11",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.087h2.61c.34 0 .679.04 1.009.122l2.758.67c.598.146 1.222.16 1.826.042l3.05-.593a4.204 4.204 0 0 0 2.127-1.107l2.158-2.1a1.503 1.503 0 0 0 0-2.168 1.61 1.61 0 0 0-2.06-.143l-2.515 1.835c-.36.263-.799.405-1.25.405h-2.427 1.545c.871 0 1.577-.687 1.577-1.534v-.307c0-.704-.492-1.317-1.194-1.487l-2.385-.58A5.027 5.027 0 0 0 10.643 1c-.965 0-2.711.799-2.711.799L5 3.025M1 2.6v5.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C1.76 10 2.04 10 2.6 10h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C5 9.24 5 8.96 5 8.4V2.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C4.24 1 3.96 1 3.4 1h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C1 1.76 1 2.04 1 2.6Z",
    stroke: "#4D4D4F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgWhiteGlove;